import React, { useState } from 'react'
import { Link, Location } from '@reach/router'
import styles from './TOCEntry.module.css'
import { pipe, trim, join, all, equals, values, filter } from 'ramda'
import DoneIcon from '@material-ui/icons/Done'
import WarningIcon from '@material-ui/icons/Warning'
import CloseIcon from '@material-ui/icons/Close'
import { Snackbar, SnackbarContent, IconButton } from '@material-ui/core'
import Form from './Form'
import Student from './Student'

const collect = pipe(join(' '), trim)

const customCompleteValidators = {
    '/verification-niveaux-langues': (x) =>
        x &&
        x.read &&
        (typeof x.requestEquivalence !== 'undefined' ||
            (typeof x.requestEquivalenceForEnglish !== 'undefined' &&
                typeof x.requestEquivalenceForGermanOrItalian !== 'undefined')),
    '/demande-equivalence': (x) => x && x.read,
    '/financement-de-vos-etudes': (x, { ahesFin = false }) => x.readAndFilledAhesForm && ahesFin,
}

const isCompleted = (o) =>
    all(
        equals(true),
        filter((x) => typeof x === 'boolean', values(o))
    )

export default (props) => {
    const { form } = Form.useContainer()
    const { student } = Student.useContainer()
    const [warningOpen, setWarningOpen] = useState(false)

    const { onNavigate, ...linkProps } = props
    const { to, disabled } = props

    const done =
        form[to] !== undefined &&
        (customCompleteValidators[to] ? customCompleteValidators[to](form[to], student) : isCompleted(form[to]))
    return (
        <Location>
            {({ location }) => {
                const { pathname } = location
                return (
                    <li
                        className={collect([
                            styles.root,
                            pathname === to ? styles.active : null,
                            done ? styles.done : null,
                        ])}
                        onClick={(e) => {
                            if (disabled) {
                                e.preventDefault()
                                setWarningOpen(true)
                            } else if (onNavigate) {
                                onNavigate()
                            }
                        }}
                    >
                        <div className={styles.iconWrapper}>
                            {done && <DoneIcon fontSize="inherit" color="inherit" />}
                        </div>

                        <Link
                            {...linkProps}
                            className={
                                disabled
                                    ? collect([styles.link, styles.disabled])
                                    : collect([styles.link, done ? styles.done : null])
                            }
                        />
                        <Snackbar
                            open={warningOpen}
                            autoHideDuration={6000}
                            onClose={() => setWarningOpen(false)}
                            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                        >
                            <SnackbarContent
                                className={styles.snackbar}
                                message={
                                    <span className={styles.snackbarMessage}>
                                        <WarningIcon className={styles.snackbarIcon} />
                                        Vous devez impérativement prendre connaissance du contenu de la page «&nbsp;Comptes d'accès&nbsp;» et compléter les actions à entreprendre afin de pouvoir continuer.
                                    </span>
                                }
                                action={
                                    <IconButton
                                        size="small"
                                        color="inherit"
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            setWarningOpen(false)
                                        }}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                }
                            />
                        </Snackbar>
                    </li>
                )
            }}
        </Location>
    )
}
